import React, { Component } from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import ReactMarkdown from "react-markdown";

import Image from "./Markdown/renderers/Image";
// import imageUrlTransformer from "./Markdown/transformers/image";
import styles from "./ReadOnly.module.css";
import { createOplogEntry } from "../../utils/oplogHelpers";

class ReadOnly extends Component {
  UNSAFE_componentWillMount () {
    // Pass state and answer to parent (Question) component right before being appended to DOM
    this.props.onInit(
      this.props.name,
      this.props.type,
      {
        discarded: this.props.discarded,
        custom: this.props.custom
      },
      { value: null },
      this.props.duration,
    );
  }

  componentDidMount() {
    this.props.doOplogUpdate(createOplogEntry(this.props.name, "in"))
  }

  componentWillUnmount() {
    this.props.doOplogUpdate(createOplogEntry(this.props.name, "out"));
  }

  render() {
    return (
      <ReactMarkdown
        className={styles.markdown}
        renderers={{ image: Image }}
        source={this.props.content}
        escapeHtml={
          false // The content must be joined with double line character to have an appropriate markdown markup. Single new line does not work for multiple images.
        }
        // transformImageUri={imageUrlTransformer(this.props.imagesHost)}
        linkTarget="_blank"
      />
    );
  }
}

ReadOnly.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  onInit: PropTypes.func,
  duration: PropTypes.number,
  imagesHost: PropTypes.string,
  // Discarded questions generated by this question
  discarded: PropTypes.array,
  custom: PropTypes.objectOf(
    PropTypes.shape({
      name: PropTypes.string,
      text: PropTypes.string
    })
  ),
};

ReadOnly.defaultProps = {
  onInit: noop,
  imagesHost: "",
  duration: 0, // Provide default value as this component doesn't have onChange handler
  discarded: [],
  custom: null,
};

export default ReadOnly;
